import { Checkbox, Group, Text } from "@mantine/core"
import { createColumnHelper } from "@tanstack/react-table"
import { Missing, CodeCell } from "@tfg/ui"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { FindCertificateRequestsForSupplierResponseDto } from "~/gen/api"
import { CertificateRequestProductionSite } from "~/pages/SupplierPortal/TraceabilityRequests/components/CertificateRequestProductionSite"
import { CertificateViewerById } from "~/pages/SupplierPortal/TraceabilityRequests/components/CertificateViewerById"

export function useBatchUpdateCertificateRequestsColumns() {
  const columnHelper =
    createColumnHelper<FindCertificateRequestsForSupplierResponseDto>()
  const { t } = useTranslation("traceability")

  return useMemo(
    () => [
      columnHelper.display({
        header: ({ table }) => (
          <Group>
            <Checkbox
              checked={table.getIsAllRowsSelected()}
              indeterminate={table.getIsSomeRowsSelected()}
              onChange={table.getToggleAllRowsSelectedHandler()} //or getToggleAllPageRowsSelectedHandler
            />
            {table.getIsAllRowsSelected() ? t("deselectAll") : t("selectAll")}
          </Group>
        ),
        id: "checkbox",
        cell: ({ row }) => (
          <Checkbox
            checked={row.getIsSelected()}
            onChange={row.getToggleSelectedHandler()}
          />
        ),
      }),
      columnHelper.accessor("type.name", {
        header: t("certificateBatchModal.labels.type"),
        cell: (cell) => cell.getValue(),
      }),
      columnHelper.accessor("productionSite", {
        header: t("batchModal.labels.productionSite"),
        cell: (cell) => (
          <CertificateRequestProductionSite productionSite={cell.getValue()} />
        ),
      }),
      columnHelper.accessor("operationPurchaseOrderReference", {
        header: t("batchModal.labels.purchaseOrderRef"),
        cell: (cell) => <CodeCell value={cell.getValue()} />,
      }),
      columnHelper.accessor("product", {
        header: t("certificateBatchModal.labels.products"),
        cell: (cell) => {
          const product = cell.getValue()
          return (
            <Text key={product.brandReference + product.color}>
              {product.brandReference} - {product.color}
            </Text>
          )
        },
      }),
      columnHelper.accessor("certificateId", {
        header: t("certificateBatchModal.labels.certificate"),
        cell: (cell) => {
          const certificateId = cell.getValue()
          if (!certificateId) {
            return <Missing />
          }
          return <CertificateViewerById certificateId={certificateId} />
        },
      }),
    ],
    [columnHelper, t]
  )
}
